define([
	"dojo/_base/declare",
	"csi",
	"csi/form/Widget",
	"csi/table/NewFrom",
	"Quality/TestRunActionMixin"
], function(declare,csi,Widget,NewFrom,TestRunActionMixin) {

	return declare([ NewFrom, TestRunActionMixin ], {
		_getFormView: function(/*Node*/node, /*Boolean*/bCheckOnly) {
			// summary: hide Test Group field
			var defView = this.inherited(arguments);
			if (defView && typeof defView === "object") {
				this._hideFields(defView, this.m_cache);
			}
			return defView;
		},

		getFormData: function() {
			// summary: when copying test run make sure to blank out color and sample fields so they don't
			// get referenced by another product. We could probably do better here by checking if the source
			// and target test runs are within the same product, but this will do for now.
			var	fd = this.inherited(arguments);
			fd.setFieldInitialValue("TestRunColor", csi.EMPTY_URL);
			fd.setFieldInitialValue("TestRunSample", csi.EMPTY_URL);
			return fd;
		}
	});
});
